import { localDateKey } from '@/lib/detail';

export const REPORT_PERIODS = ['month', 'quarter', 'year'] as const;
export type ReportPeriod = (typeof REPORT_PERIODS)[number];

/** For a value from a `<select>` or a URL, neither of which the compiler can vouch for. */
export function isReportPeriod(value: string | null | undefined): value is ReportPeriod {
  return (REPORT_PERIODS as readonly string[]).includes(value ?? '');
}

/**
 * The date window each period option maps to, as `GET /admin/reports` wants it:
 * `from` inclusive, `to` exclusive, both ISO-8601 dates.
 *
 * The selector speaks in periods; the API speaks in dates. Sending the raw
 * keyword — `?from=month` — fails the endpoint's `@IsISO8601()` and returns 422
 * with no `to` at all, so the translation has to happen here, once.
 */
export function periodRange(period: ReportPeriod): { from: string; to: string } {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  // `to` is exclusive, so the start of tomorrow is what includes today.
  const to = new Date(year, month, now.getDate() + 1);
  const from =
    period === 'month'
      ? new Date(year, month, 1) // this month
      : period === 'quarter'
        ? new Date(year, month - 2, 1) // this month and the two before it
        : new Date(year, 0, 1); // this year
  return { from: localDateKey(from), to: localDateKey(to) };
}
